module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/b0da87c1148b444b88a2902e8efe577c.png";